import { render, staticRenderFns } from "./IPCCard.vue?vue&type=template&id=e0e4ac52&"
import script from "./IPCCard.vue?vue&type=script&lang=js&"
export * from "./IPCCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports